// Index files are intended for importing and executing functions and classes only. They should not contain any logic.
import sectionIngredients from './section-ingredients'
import { MitoqStickyAddToCart } from './mitoq-sticky-add-to-cart'

function init() {
  document.addEventListener('DOMContentLoaded', function () {
    sectionIngredients()

    // eslint-disable-next-line no-new
    new MitoqStickyAddToCart()
  })
}

export default init
